import { keys } from 'lodash';
import * as React from 'react';
import ReactMinimalPieChart from 'react-minimal-pie-chart';

import { Bem } from '../../service/Bem/Bem';
import { DisplayPoint, PointColor, Screen } from '../../typings/displayMap';

import './PlaceMarkIndoor.css';

export interface PlaceMarkIndoorProps {
    pointData: DisplayPoint;
    selectedScreensPoint: string[];
}

export class PlaceMarkIndoor extends React.Component<PlaceMarkIndoorProps> {
    render() {
        const { pointData: point, selectedScreensPoint: selected } = this.props;
        const { screens } = point;

        const colors = screens.reduce(
            (result: { [id: string]: number }, screen: Screen) => {
                const deletedScreenWeight = screen.deletedScreenWeight || 0;

                if (deletedScreenWeight) {
                    if (!result[PointColor.grey]) {
                        result[PointColor.grey] = 0;
                    }

                    result[PointColor.grey] += deletedScreenWeight;
                }

                if (selected.includes(screen.id)) {
                    if (!result[PointColor.green]) {
                        result[PointColor.green] = 0;
                    }

                    result[PointColor.green] +=
                        screen.screenWeight - deletedScreenWeight;
                } else {
                    if (!result[PointColor.blue]) {
                        result[PointColor.blue] = 0;
                    }

                    result[PointColor.blue] +=
                        screen.screenWeight - deletedScreenWeight;
                }

                return result;
            },
            {}
        );

        const pieChartColors = keys(colors).reduce(
            (
                result: { value: number; color: string }[],
                color: string
            ): { value: number; color: string }[] => {
                if (colors[color]) {
                    result.push({
                        value: colors[color],
                        color: color
                    });
                }

                return result;
            },
            []
        );

        return (
            <div className={Bem.cls('placemark-indoor')}>
                <ReactMinimalPieChart
                    className={Bem.cls('placemark-indoor', 'pie-chart')}
                    lineWidth={30}
                    paddingAngle={5}
                    label={() =>
                        screens.reduce(
                            (count, item) => count + item.screenWeight,
                            0
                        )
                    }
                    labelStyle={{
                        fontSize: '30px',
                        fill: '#121212',
                        dominantBaseline: 'middle'
                    }}
                    rounded={pieChartColors.length <= 1}
                    labelPosition={0}
                    data={pieChartColors}
                />
            </div>
        );
    }
}
